"use client"

import React from "react"
import { generateIconElements, IconVariant } from "./iconUtils"

// ------------------------------------------------------------------------------
// IconSVG Component - Circular agnos.ai icon
// Single source of truth for all icon variants
// Perfect for mobile navigation, favicons, and app icons
// ------------------------------------------------------------------------------
type IconSVGProps = {
  className?: string
  variant?: IconVariant
}

/**
 * IconSVG Component - Circular logo that can be used as a favicon,
 * mobile navigation, and app icons.
 *
 * This version runs client-side in the browser and can fully rely
 * on the availability of CSS variables such as:
 *
 * --color-brand-gradient-start (for the brand-gradient variant)
 * --color-brand-gradient-end (for the brand-gradient variant)
 * --color-primary (for the solid variant)
 *
 * These variables are defined in the globals.css file and are
 * automatically generated from the brand colors.
 */
export const IconSVG = ({
  className,
  variant = IconVariant.BRAND_GRADIENT,
}: IconSVGProps) => {
  // Get the SVG elements from our utility
  // CRITICAL: DO NOT CHANGE THIS CALL!!!
  const svgElements = generateIconElements({
    variant: variant,
  })

  if (!React.isValidElement(svgElements)) {
    console.error("IconSVG: Invalid SVG elements:", svgElements)
    return null
  }

  // Apply className directly to the SVG element by cloning it with proper typing
  return React.cloneElement(
    svgElements as React.ReactElement<React.SVGProps<SVGSVGElement>>,
    {
      className: className,
    }
  )
}
